<template>
  <div class="form-group">
    <label :for="id" class="form-label">{{ label }}</label>
    <select :id="id" class="form-control" v-model="selectedItem">
      <option v-if="includeEmptyOption && showEmpty" value="">
        {{ emptyOptionMessage }}
      </option>
      <option v-for="item in items" :key="getKey(item)" :value="item.value">
        {{ item.label }}
      </option>
    </select>
    <slot name="validation"></slot>
  </div>
</template>
<script>
import { newGuid } from "@/util/guid";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: null,
    items: {
      type: Array,
      required: true,
    },
    includeEmptyOption: {
      type: Boolean,
      required: false,
      default: false,
    },
    emptyOptionMessage: {
      type: String,
      required: false,
      default: "",
    },
    allowSelectEmptyOption: {
      type: Boolean,
      required: false,
      default: false,
    },
    valueAsKey: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: function () {
    return {
      showEmpty: true,
    };
  },
  computed: {
    selectedItem: {
      get: function () {
        return this.modelValue;
      },
      set: function (newValue) {
        if (!this.allowSelectEmptyOption) {
          this.showEmpty = false;
        }

        this.$emit("update:modelValue", newValue);
      },
    },
  },
  methods: {
    getKey: function (item) {
      if (this.valueAsKey) {
        return item.value;
      }

      return newGuid();
    },
  },
};
</script>
